import React from 'react';

import { money } from './changeRequestFormat';

const KIND_MONEY = 'money';

const shown = (change, value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    return change.kind === KIND_MONEY ? money(value) : value;
};

/**
 * What a workforce position save changed: each field with its value before and
 * after, then what the change did to the position's cost. A position added has
 * nothing before, and one removed nothing after.
 */
export default function PositionChanges({ row }) {
    if (!row.field_changes?.length) {
        return null;
    }

    const total = Number(row.total_amount ?? 0);
    const signed = row.action_type === 'decrease' ? -total : total;

    return (
        <div>
            <div className="bc-eyebrow">{$t('What changed')}</div>
            <div className="inbud-table_wrapper bc-table-wrapper">
                <table className="inbud-table bc-table">
                    <thead>
                        <tr>
                            <th>{$t('Field')}</th>
                            <th>{$t('From')}</th>
                            <th>{$t('To')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {row.field_changes.map((change) => (
                            <tr key={change.field}>
                                <td className="tw-font-medium">{change.label}</td>
                                <td>{shown(change, change.from)}</td>
                                <td>{shown(change, change.to)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="bc-sub tw-mt-1.5">
                {Math.round(total) === 0
                    ? $t('Cost change: {{amount}}', { amount: $t('No change') })
                    : $t('Cost change: {{amount}}', { amount: signed > 0 ? `+${money(signed)}` : money(signed) })}
            </div>
        </div>
    );
}
